import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { spotFinder } from "../app/endpoints";
import axiosBaseQuerySpotfinder from "./axiosBaseQuerySpotfinder";

export const contactSupportApi = createApi({
    reducerPath: "contactSupportApi",
    baseQuery: axiosBaseQuerySpotfinder({
        baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL,
    }),
    tagTypes: ["contactSupport"],
    endpoints: (builder) => ({
        addQueryContact: builder.mutation({
            query: (body) => {
                return {
                    url: spotFinder.contactSupportController.addQueryContact,
                    method: "POST",
                    body: body.payload,
                };
            },
        }),
        getCategoryList: builder.mutation({
            query: (body) => {
                return {
                    url: spotFinder.VehicleCategoryController.getCategoryList,
                    method: "GET",
                    headers: {Authorization: `Bearer ${body.token}`},
                };
            },
        }),

    }),

    
});

export const { useAddQueryContactMutation,useGetCategoryListMutation} =contactSupportApi;
